/**
 * Create object with original data plus forgery data if defined
 * @param {Object} antiforgeryData - token information
 * @param {string} antiforgeryData.name
 * @param {string} antiforgeryData.value
 * @param {Object} formData
 * @returns {Object}
 */
export const setAntiForgeryToken = (antiforgeryData, formData) => {
  const { name, value } = antiforgeryData;
  return !name ? formData : { ...formData, [name]: value };
};
